import { prop, propArray, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "../../cases/_types/case";
import { MailMessageRecipient } from "./mail-message-receipt";
import { Relationship } from "src/app/core/jsonapi/relationship";
import { RelationshipArray } from "src/app/core/jsonapi/relationship-array";

export enum SMSMessageState {
    Pending = "Pending",
    Error = "Error",
    Sent = "Sent",
    Received = "Received",
    Sending = "Sending"
}


export class SMSMessage extends Resource {
    public override type = 'smsMessages';

    @prop()
    public caseId!: string;

    @prop()
    @required()
    public content!: string;


    @prop()
    public state: SMSMessageState = SMSMessageState.Pending;

    @prop()
    @required()
    public stateDate: Date = new Date();


    @prop()
    public stateInfo?: string;

    @prop()
    public phoneNumber!: string;

}